/// Asset paths for day/night sky (LDPI).
/// Port of mobile/lib/game/sky/sky_assets.dart.

export const skyAssets = {
  moonPhase: 'new/moon/moon_phase.png',
  starBright: 'new/star/star_bright.png',
  star: 'new/star/star.png',
  starDim: 'new/star/star_dim.png',

  sun: 'new/sun/sun.png',
  cloud1: 'new/cloud/cloud_1.png',
  cloud2: 'new/cloud/cloud_2.png',
  cloud3: 'new/cloud/cloud_3.png',
} as const;

export const cloudAssets: readonly string[] = [
  skyAssets.cloud1,
  skyAssets.cloud2,
  skyAssets.cloud3,
];

/// Horizontal frames in the moon phase sheet (160x40).
/// First 3 are 20x40, full moon is 40x40, last 3 are 20x40.
export const moonPhases = {
  count: 7,
  height: 40.0,
  /// [srcX, srcWidth] for each phase index 0..6.
  frames: [
    [0, 20],
    [20, 20],
    [40, 20],
    [60, 40],
    [100, 20],
    [120, 20],
    [140, 20],
  ] as readonly (readonly [number, number])[],
} as const;
